<lib-prod-form  *ngIf="!data.records"
                [fields]="fields" [data]="data"
                (onSubmitEvent)="submit($event)"
                (selectValueEvent)="selectValueEvent($event)"
                (passFormEvent)="onFormOutput($event)"></lib-prod-form>

<mat-tab-group *ngIf="data.records" (selectedTabChange)="onTabChanged($event);" class="height-100">
  <mat-tab>
    <ng-template mat-tab-label><i class="material-icons">directions_car_filled</i>{{'vehicle.form.details_tab_title' | translate}}
    </ng-template>
    <ng-template matTabContent>
      <div class="row height-100 m-0">
        <div class="col-12 col-sm-5 p-0 height-100">
          <lib-prod-header [title]="title">
            <lib-prod-form [fields]="fields" [data]="data"
                           (onSubmitEvent)="submit($event)"
                           [formButtons]="formButtons"
                           (passFormEvent)="onFormOutput($event)"></lib-prod-form>
          </lib-prod-header>
        </div>
        <div class="col-12 col-sm-7 p-0 height-100">
          <app-battery-events-grid [dialogData]="dialogData"
                                   [ngClass]="{'disabled-grid': data.records.getSize() > 1}"></app-battery-events-grid>
        </div>
      </div>
    </ng-template>
  </mat-tab>

  <mat-tab disabled="{{data.records.getSize() > 1}}">
    <ng-template mat-tab-label><i class="material-icons">map</i> {{'vehicle.form.map_tab_title' | translate}}</ng-template>
    <ng-template matTabContent>
      <lib-prod-header [title]="mapTitle">
        <lib-prod-map
          [mapName]="mapName"
          [markers$]="markers$"
          [mapDefaultZoom]="18"
          [isMarkersHasCircles]="true"></lib-prod-map>
      </lib-prod-header>
    </ng-template>
  </mat-tab>
</mat-tab-group>
